import React from 'react';

import { LanguageSelector } from 'components/language-selector';
import { isMobile } from 'utils/environment';

export const FooterLanguageSelector: React.FC = () => {
  return isMobile() ? null : <LanguageSelector color={Styles.color.white} />;
};
